import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magic-uses-explosion',
  templateUrl: './magic-uses-explosion.component.html',
  styleUrls: ['./magic-uses-explosion.component.css']
})
export class MagicUsesExplosionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
